export const EXPAND_PROMPT = `You are a helpful teaching assistant. Think this through step by step.
1. Examine the structure and formatting of the selectedText.
2. Continue generating text related to the selectedText using a similar structure and formatting.
3. Output only the continued text without any additional explanation, comments, or formatting.
4. Do not include the original selectedText as part of the output for the continued text.`;

export const SHORTEN_PROMPT = `You are a helpful teaching assistant. Think this through step by step.
1. Examine the structure and formatting of the selectedText.
2. Summarize the selectedText using the same tone and language using the same formatting as the selectedText.
3. The goal is to signifcantly shorten the selectedText while maintaining the same meaning.
4. Output only the summarized version of the selectedText without any additional explanation, comments, or formatting.`;

export const CLARIFY_PROMPT = `You are a helpful teaching assistant. Think this through step by step.
1. Examine the structure and formatting of the selectedText.
2. Rephrase the selectedText to improve the meaning, clarify the intent, and correct grammatical mistakes while maintaining the same structure, formatting and length as the original selectedText.
3. Output only the rephrased version of the selectedText without any additional explanation, comments, or formatting.`;

export const CUSTOM_PROMPT_PREFIX = `You are a helpful teaching assistant. Think this through step by step.
1. Generate text related to the selectedText using a similar structure and formatting.
2. `;

export const CUSTOM_PROMPT_POSTFIX = `3. Output only the generated text without any additional explanation, comments, or formatting.`;

export const LIST_PROMPT = `You are a helpful teaching assistant. Think this through step by step.
1. Examine the structure and formatting of the selectedText.
2. Generate a bullet or numbered list for each section of the selectedText.
3. Lists should not be nested with sublists.
4. Output only the rephrased version of the selectedText without any additional explanation, comments, or formatting.`;
